import { render, staticRenderFns } from "./PlainTableOrder.vue?vue&type=template&id=8c351728"
import script from "./PlainTableOrder.vue?vue&type=script&lang=js"
export * from "./PlainTableOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports